<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>
                <wizard-header :title="this.title"></wizard-header>

                <div class="row">
                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Nome*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="text" v-model="user_first_name" placeholder="Marco" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Cognome*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="text" v-model="user_last_name" placeholder="Bianchi" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Email*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" :class="{'error' : emailError !== ''}" type="email" v-model="user_email" @blur="validateEmail" placeholder="marcob@gmail.com" />
                                <span class="wizard-error" v-if="emailError !== ''">
                                    {{ emailError }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Telefono*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <input class="form-control" type="number" v-model="user_phone" placeholder="+ 39 .." />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                            </div>
                            <div class="col-lg-10 col-12 d-flex align-items-center">
                                <input class="form-control mr-2" type="checkbox" v-model="accept_privacy" name="privacy" required />
                                <label class="font-weight-normal">Ho letto e accetto l'informativa sulla <a href="javascript"> privacy </a> </label>
                            </div>
                        </div>
                    </div>
                </div>

                <wizard-footer :step="this.step"
                               :display_next_button="display_next_button"
                               :wizard_data="getWizardData"
                               :user="this.user"
                >
                </wizard-footer>

            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>

            </wizard-box-right>
        </template>
    </wizard-layout>
</template>


<script>

import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";
import {redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['data', 'user'],

    components: {
        Label,
        Button,
        WizardProgress,
        WizardFooter, WizardHeader, WizardStep, WizardBoxLeft, WizardLayout, WizardBoxRight },

    computed: {
        display_next_button() {
            return this.fieldsAreEmpty()
        },

        getWizardData() {
            return {
                user_first_name: this.user_first_name,
                user_last_name: this.user_last_name,
                user_email: this.user_email,
                user_phone: this.user_phone
            }
        }
    },

    data() {
        let current_property = JSON.parse(localStorage.getItem('current_property'))
        return {
            step: 6,
            header_step: 7,
            title: "Inserisci i tuoi dati",
            progress: 4,
            progress_title: "Ricevi subito la tua valutazione",
            progress_description: "Compila il modulo con i tuoi dati e ricevi immediatamente la valutazione sulla mail da te indicata.",
            user_first_name: current_property ? current_property.user_first_name :'',
            user_last_name: current_property ? current_property.user_last_name :'',
            user_email: current_property ? current_property.user_email :'',
            user_phone: current_property ? current_property.user_phone :'',
            accept_privacy: false,
            emailError: ''
        }
    },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        fieldsAreEmpty() {
            return (this.user_first_name != null && this.user_last_name != null && (this.user_email != null && this.emailError === '') && this.user_phone != null && this.accept_privacy !== false)
        },

        validateEmail() {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user_email)) {
                this.emailError = '';
            } else {
                this.emailError = '*Inserisci una email valida, deve contenere @';
            }
        }
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(),this.step,'test',this.$inertia)
    }
}

</script>
